// US & Canada timezones - the most commonly used values
export const TIMEZONE_REFERENCE = [
  // United States
  { value: 'US/Eastern', label: 'Eastern (NY, FL, GA)' },
  { value: 'US/Central', label: 'Central (TX, IL, MN)' },
  { value: 'US/Mountain', label: 'Mountain (CO, AZ)' },
  { value: 'US/Pacific', label: 'Pacific (CA, WA, OR)' },
  { value: 'US/Alaska', label: 'Alaska' },
  { value: 'US/Hawaii', label: 'Hawaii' },
  { value: 'US/Arizona', label: 'Arizona (no DST)' },
  // Canada
  { value: 'Canada/Atlantic', label: 'Atlantic (NS, NB)' },
  { value: 'Canada/Eastern', label: 'Eastern (ON, QC)' },
  { value: 'Canada/Central', label: 'Central (MB, SK)' },
  { value: 'Canada/Mountain', label: 'Mountain (AB)' },
  { value: 'Canada/Pacific', label: 'Pacific (BC)' },
  { value: 'Canada/Newfoundland', label: 'Newfoundland' },
];
